import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { ErrorBox, Field } from '../components/ui';
import Icon from '../components/Icon';

export default function Login({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await api.post('/api/auth/login', { email, password }); onLogin(); nav('/'); } catch (err: any) { setError(err.message); } finally { setBusy(false); }
  };
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100%', padding: 16, background: 'linear-gradient(135deg, #0f766e 0%, #115e59 100%)' }}>
      <form className="card stack" style={{ width: 'min(400px, 100%)', padding: 32, gap: 16 }} onSubmit={submit} aria-labelledby="login-h">
        <div className="row" style={{ gap: 12 }}>
          <span className="brand-mark"><Icon name="layers" size={20} /></span>
          <strong style={{ fontSize: 18 }}>בונה באנרים</strong>
        </div>
        <div>
          <h1 id="login-h" style={{ marginBottom: 4 }}>ברוכים הבאים</h1>
          <div className="muted">התחברו כדי להמשיך לעבוד על הקמפיינים.</div>
        </div>
        <ErrorBox error={error} />
        <Field label="אימייל"><input type="email" className="ltr" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required autoFocus /></Field>
        <Field label="סיסמה">
          <span className="row" style={{ flexWrap: 'nowrap' }}>
            <input type={show ? 'text' : 'password'} className="ltr" style={{ flex: 1 }} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
            <button type="button" className="btn" onClick={() => setShow((x) => !x)} aria-pressed={show}>{show ? 'הסתרה' : 'הצגה'}</button>
          </span>
        </Field>
        <button className="btn primary big" disabled={busy}>{busy ? 'נכנס…' : 'כניסה'}</button>
        <div className="small muted">שכחתם סיסמה? בקשו ממנהל המערכת קישור חד-פעמי לקביעת סיסמה חדשה.</div>
      </form>
    </div>
  );
}
